<input #fileInput type="file" (change)="fileInputChange($event)"/>
<button
  class="fileBtn"
  type="button"
  (click)="fileInput.click()"
  (click)="markAsTouched()"
  [hidden]="croppedImage"
>
  Seleccionar Imagen
</button>
<commonui-preload-img
  [urlImg]="getUrlAsString()"
  [imageHeight]="100"
  [imageWidth]="100"
  containerClass="d-flex justify-content-center"
  imgClass="w-auto h-100"
  unit="%"
  [containerHeight]="100"
  [containerWidth]="100"
  [hidden]="!croppedImage"
>
</commonui-preload-img>
<button
  mat-icon-button
  class="deleteBtn"
  type="button"
  (click)="deleteImage()"
  [hidden]="!croppedImage"
>
  <mat-icon svgIcon="trash-can"></mat-icon>
</button>
